var map = {
	"./mosaic01.webp": 90,
	"./mosaic02.webp": 435,
	"./mosaic03.webp": 352,
	"./mosaic04.webp": 425,
	"./mosaic05.webp": 702,
	"./mosaic06.webp": 399,
	"./mosaic07.webp": 460,
	"./mosaic08.webp": 741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 888;